import gql from 'graphql-tag';

import {getProjectInternalId} from '../../components/RunSelector/util';
import * as Generated from '../../generated/graphql';
import * as Filter from '../../util/filters';
import * as SelectionManager from '../../util/selectionmanager';
import * as ViewHooks from '../views/hooks';
import {RunSetPart} from '../views/runSet/types';

///// Query definition

export const RUN_SET_SUMMARY_QUERY = gql`
  query RunSetSummary(
    $projectName: String!
    $entityName: String!
    $selections: JSONString!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      selectedCount: runCount(filters: $selections)
    }
  }
`;

export const RUN_SET_SUMMARY_BY_ID_QUERY = gql`
  query RunSetSummaryByID($internalId: ID!, $selections: JSONString!) {
    project(internalId: $internalId) {
      id
      selectedCount: runCount(filters: $selections)
    }
  }
`;

export interface RunSetSummaryQueryData {
  project: {
    id: string;
    selectedCount: number;
  };
}
interface InputProps {
  pageEntityName: string;
  pageProjectName: string;
  internalId?: string;
  runSet: RunSetPart;
}

export function useRunSetSummaryQuery(props: InputProps) {
  const {pageEntityName, pageProjectName, runSet} = props;
  const internalId = getProjectInternalId(runSet.project?.id);

  const filters = ViewHooks.usePart(runSet.filtersRef);
  const groupSelections = ViewHooks.usePart(runSet.groupSelectionsRef);

  const queryWithID = Generated.useRunSetSummaryByIdQuery({
    variables: {
      internalId: internalId ?? '',
      selections: JSON.stringify(
        Filter.toMongo(
          Filter.And([filters, SelectionManager.toRunFilter(groupSelections)])
        )
      ),
    },
    skip: internalId == null,
  });
  const queryWithNoID = Generated.useRunSetSummaryQuery({
    variables: {
      entityName: runSet.project ? runSet.project.entityName : pageEntityName,
      projectName: runSet.project ? runSet.project.name : pageProjectName,
      selections: JSON.stringify(
        Filter.toMongo(
          Filter.And([filters, SelectionManager.toRunFilter(groupSelections)])
        )
      ),
    },
    skip: internalId != null,
  });
  if (internalId != null) {
    return {
      ...queryWithID,
      initialLoading: queryWithID.loading && !queryWithID.data,
    };
  }
  return {
    ...queryWithNoID,
    initialLoading: queryWithNoID.loading && !queryWithNoID.data,
  };
}
